import { Component, Input, OnDestroy, forwardRef } from '@angular/core';
import { ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Subscription } from 'rxjs';

@Component({
  selector: 'custom-radio-button-accesor',
  templateUrl: './custom-radio-button-accesor.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(()=> CustomRadioButtonAccesorComponent),
      multi: true
    }
  ]
})
export class CustomRadioButtonAccesorComponent implements ControlValueAccessor, OnDestroy  {
  @Input() options: any[] = [];
  @Input() class: string = '';
  value = new FormControl([undefined, [], []]);
  subscriptions: Subscription[] = [];
  propagateChange: any = (f:any) =>{}
  onTouch: any = () => {}

  writeValue(input: any): void {
    this.value.setValue(input);
  }
  registerOnChange(fn: any): void {
    this.subscriptions.push(
      this.value.valueChanges.subscribe(fn)
    );
  }
  ngOnDestroy() {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

  registerOnTouched(fn: any){
    this.onTouch = fn;
  }

}
